const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/rbac/role.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { RoleListFilterParamSchema } from '@apps/main/features/admin/pages/rbac/role-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/rbac/role')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: search => RoleListFilterParamSchema.parse(search)
});